import { ConnectButton } from 'components/ConnectButton';
import { AccountInfo } from 'structure/Layouts/LayoutWithSideBar/AccountInfo';
import { useClientRenderDelay } from 'utils/hooks/useClientRenderDelay';
import { useConnection } from 'wagmi';

export const ConnectInfoButton = () => {
  const { isConnected } = useConnection();
  const csr = useClientRenderDelay();

  return (
    <>
      {!csr && (
        <div className='rounded-main h-[38px] w-[148px] animate-pulse bg-[#191A1E]' />
      )}
      {csr && isConnected && (
        <AccountInfo button={{ className: 'bg-[#191A1E]' }} />
      )}
      {csr && !isConnected && (
        <ConnectButton className='px-10 py-2 text-base' />
      )}
    </>
  );
};
